import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "./App";
import { normalizeHashRouterUrl } from "@/lib/portal/base-path";
import "@/styles/globals.css";

normalizeHashRouterUrl();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
